import axios from "axios";
import { setAlert } from "./alert";
import {
  GET_POSTS,
  GET_INFINITE_SCROLL_POSTS,
  GET_POST_COMMENTS,
  GET_POST_COMMENT_REPLIES,
  POST_ERROR,
  UPDATE_REACTION,
  DELETE_POST,
  ADD_POST,
  PIN_POST,
  UNPIN_POST,
  ADD_COMMENT,
  REMOVE_COMMENT,
  REMOVE_REPLY,
  ADD_POST_REPLY,
  CLEAR_POSTS,
  GET_POSTS_BY_REACTION,
} from "./types";

// Get posts
export const getPosts = (channelid) => async (dispatch) => {
  dispatch({ type: CLEAR_POSTS });
  try {
    const res = await axios.get(`/api/posts/${channelid}`);

    dispatch({
      type: GET_POSTS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: POST_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get posts by reaction type
export const getPostsByReaction = (channelid, reaction) => async (dispatch) => {
  const formData = new FormData();

  formData.append("channelid", JSON.stringify(channelid));
  formData.append("reaction", JSON.stringify(reaction));

  const config = {
    data: formData,
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(`/api/posts/post_reactions`, formData, config);

    dispatch({
      type: GET_POSTS_BY_REACTION,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: POST_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get infinite scroll posts
export const infiniteScrollPosts = (channelid, count) => async (dispatch) => {
  const formData = new FormData();
  formData.append("count", JSON.stringify(count));

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(
      `/api/posts/${channelid}/infinite_scroll`,
      formData,
      config
    );

    dispatch({
      type: GET_INFINITE_SCROLL_POSTS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: POST_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get post comments
export const getPostComments = (postId, channelid) => async (dispatch) => {
  const formData = new FormData();

  formData.append("reaction", JSON.stringify(postId));
  formData.append("channelid", JSON.stringify(channelid));

  const config = {
    data: formData,
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(`/api/posts/post/comments`, formData, config);

    dispatch({
      type: GET_POST_COMMENTS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: POST_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get post comment replies
export const getPostCommentReplies =
  (commentId, channelid) => async (dispatch) => {
    const formData = new FormData();

    formData.append("id", JSON.stringify(commentId));
    formData.append("channelid", JSON.stringify(channelid));

    const config = {
      data: formData,
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      const res = await axios.post(`/api/posts/post/replies`, formData, config);

      dispatch({
        type: GET_POST_COMMENT_REPLIES,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: POST_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Add reaction
export const addReaction = (id, channelid, type) => async (dispatch) => {
  const formData = new FormData();
  formData.append("id", JSON.stringify(id));
  formData.append("type", JSON.stringify(type));
  formData.append("channelid", JSON.stringify(channelid));
  const config = {
    data: formData,
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(`/api/posts/react`, formData, config);

    dispatch({
      type: UPDATE_REACTION,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: POST_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Add post
export const addPost = (Post, channelid, isPinnedPost) => async (dispatch) => {
  const formData = new FormData();

  formData.append("text", JSON.stringify(Post.text));

  formData.append("photo", Post.photo);

  formData.append("video", Post.video);

  formData.append("gif", JSON.stringify(Post.gif));

  formData.append("channelid", JSON.stringify(channelid));

  formData.append("isPinnedPost", JSON.stringify(isPinnedPost));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post("/create_post", formData, config);

    dispatch({
      type: ADD_POST,
      payload: res.data,
    });

    dispatch(setAlert("Post Created"));
  } catch (err) {
    dispatch({
      type: POST_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Delete post
export const deletePost = (id, channelid) => async (dispatch) => {
  const formData = new FormData();
  formData.append("id", JSON.stringify(id));
  formData.append("channelid", JSON.stringify(channelid));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(`/api/posts/delete_post`, formData, config);

    dispatch({
      type: DELETE_POST,
      payload: res.data,
    });

    dispatch(setAlert("Post Removed"));
  } catch (err) {
    dispatch({
      type: POST_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Pin post
export const pinPost = (id, channelid) => async (dispatch) => {
  const formData = new FormData();
  formData.append("id", JSON.stringify(id));
  formData.append("channelid", JSON.stringify(channelid));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(`/api/posts/pin_post`, formData, config);

    dispatch({
      type: PIN_POST,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: POST_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Unpin post
export const unpinPost = (id, channelid) => async (dispatch) => {
  const formData = new FormData();
  formData.append("id", JSON.stringify(id));
  formData.append("channelid", JSON.stringify(channelid));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(`/api/posts/unpin_post`, formData, config);

    dispatch({
      type: UNPIN_POST,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: POST_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Add comment
export const addPostComment =
  (id, channelid, comment, gif) => async (dispatch) => {
    const formData = new FormData();

    formData.append("id", JSON.stringify(id));
    formData.append("channelid", JSON.stringify(channelid));
    formData.append("text", JSON.stringify(comment));
    formData.append("gif", JSON.stringify(gif));

    const config = {
      data: formData,
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      const res = await axios.post("/api/posts/postcomment", formData, config);

      dispatch({
        type: ADD_COMMENT,
        payload: res.data,
      });

      dispatch(setAlert("Comment Added"));
    } catch (err) {
      dispatch({
        type: POST_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Add reply to post comment
export const addPostReply =
  (postId, commentId, channelid, replyText, replyGif) => async (dispatch) => {
    const formData = new FormData();

    formData.append("postId", JSON.stringify(postId));
    formData.append("commentId", JSON.stringify(commentId));
    formData.append("channelid", JSON.stringify(channelid));
    formData.append("replyText", JSON.stringify(replyText));
    formData.append("replyGif", JSON.stringify(replyGif));

    const config = {
      data: formData,
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      const res = await axios.post(
        "/api/posts/postcomment/postreply",
        formData,
        config
      );

      dispatch({
        type: ADD_POST_REPLY,
        payload: res.data,
      });

      dispatch(setAlert("Comment Added"));
    } catch (err) {
      dispatch({
        type: POST_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Delete comment
export const deleteComment = (id, commentId, channelid) => async (dispatch) => {
  const formData = new FormData();

  formData.append("postId", JSON.stringify(id));
  formData.append("commentId", JSON.stringify(commentId));
  formData.append("channelid", JSON.stringify(channelid));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(
      `/api/posts/postcomment/deletecomment`,
      formData,
      config
    );

    dispatch({
      type: REMOVE_COMMENT,
      payload: res.data,
    });

    dispatch(setAlert("Comment Removed"));
  } catch (err) {
    dispatch({
      type: POST_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Delete reply
export const deleteReply =
  (commentId, replyId, channelid) => async (dispatch) => {
    const formData = new FormData();

    formData.append("commentId", JSON.stringify(commentId));
    formData.append("replyId", JSON.stringify(replyId));
    formData.append("channelid", JSON.stringify(channelid));

    const config = {
      data: formData,
      header: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    };

    try {
      const res = await axios.post(
        `/api/posts/postcomment/postreply/deletereply`,
        formData,
        config
      );

      dispatch({
        type: REMOVE_REPLY,
        payload: res.data,
      });

      dispatch(setAlert("Comment Removed"));
    } catch (err) {
      dispatch({
        type: POST_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };
